import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Get saved language or detect from browser
const getInitialLanguage = () => {
  const savedLng = localStorage.getItem('i18nextLng');
  if (savedLng) return savedLng;

  const lang = navigator.language || navigator.userLanguage;
  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('it')) return 'it';
  if (lang.startsWith('pt')) return 'pt';
  if (lang.startsWith('fr')) return 'fr';
  if (lang.startsWith('de')) return 'de';
  return 'es'; // default
};

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      es: {
        translation: {
          welcome: 'Bienvenido a EcoScienceInnova',
          login: 'Iniciar Sesión',
          register: 'Registrarse',
          yes: 'Sí',
          no: 'No',
          chatPlaceholder: 'Escribe tu mensaje...',
          changeLanguage: 'Cambiar idioma a',
          home: 'Inicio',
          comunidad: 'Comunidad',
          memberships: 'Membresías',
          contact: 'Contacto',
          tagline: 'Ciencia e Innovación con impacto real',
          investigador: 'Investigador',
          investigadorDesc: 'Gestiona tus estudios, publica resultados y coordina investigación clínica con herramientas avanzadas.',
          investigadorBtn: 'Soy investigador',
          aspirante: 'Aspirante a estudios',
          aspiranteDesc: 'Participa en ensayos clínicos de vanguardia, contribuye a la ciencia y accede a nuevos tratamientos.',
          aspiranteBtn: 'Quiero participar',
          institucion: 'Instituciones',
          institucionDesc: 'Participa en investigaciones con impacto real y contacta talentos de investigación.',
          institucionBtn: 'Registrar entidad',
          footerText: 'Conectando la investigación médica con el futuro mediante innovación tecnológica.',
          followUs: 'Síguenos en:',
          contactInfo: 'Contacto',
          email: 'info@ecoscienceinnova.com',
          phone: '+1 (555) 123-4567',
          address: 'Calle Médica 123, Ciudad Salud',
          aboutUs: 'Nosotros',
          privacyPolicy: 'Política de Privacidad',
          allRightsReserved: 'Todos los derechos reservados',
          copyrightDetailed: '<span style="color: #FF6600">Eco</span>ScienceInnova<sup>®</sup> marca registrada de <span style="color: #FF6600">CIIC Consultores S.A.S</span>. © 2026 Todos los derechos reservados.',
          platform: 'Plataforma',
          studies: 'Estudios',
          howItWorks: 'Cómo funciona',
          dataSecurity: 'Seguridad de datos',
          company: 'Empresa',
          press: 'Prensa',
          legal: 'Legal',
          termsOfService: 'Términos de servicio',
          ethicsCode: 'Código de ética',
          acercaDe: 'Acerca de',
          common: {
            privacy: 'Privacidad',
            terms: 'Términos',
            cookies: 'Cookies'
          },
          header: {
            aiSearchPlaceholder: 'Pregunta a la IA de investigación...'
          },
          tabs: {
            forYou: 'Para ti',
            recent: 'Reciente',
            myTopics: 'Mis temas',
            filter: 'Filtrar'
          },
          composer: {
            placeholder: '¿Qué estás investigando hoy?',
            publish: 'Publicar'
          },
          post: {
            share: 'Compartir',
            mentions: 'Menciones'
          },
          widgets: {
            ecoAiInsight: 'EcoAI Insight',
            insightDesc: 'Basado en tu actividad reciente, recomendamos revisar el nuevo protocolo de seguridad para inmunoterapia Fase II.',
            viewRecommendation: 'Ver recomendación',
            trendsTitle: 'Temas en tendencia',
            viewMoreSuggestions: 'Ver más sugerencias'
          },
          community: {
            hero: {
              title: 'Una Comunidad Vibrante',
              subtitle: 'Únete a miles de pacientes e investigadores en la revolución científica.',
              registerBtn: 'Regístrate y Únete',
              chat: 'Chat Secreto',
              supportGroups: 'Grupos de Apoyo',
              shareExperiences: 'Comparte Experiencias'
            },
            search: {
              placeholder: '¿Preguntar a la IA? Ej: ¿Cómo funciona un ensayo clínico?',
              btn: 'Consultar IA Comunitaria'
            },
            results: {
              title: 'IA Insights para ti',
              study: 'Investigación Clínica',
              recommended: 'Recomendado',
              glosary: 'Glosario Médico',
              apply: 'Aplicar para participar',
              learnMore: 'Saber más'
            },
            resources: {
              title: 'Recursos Educativos',
              subtitle: 'Contenido curado por especialistas para tu bienestar.',
              tag: '100% EDUCACIÓN',
              videos: 'Video Tutoriales',
              videosDesc: 'Aprende los conceptos básicos de la investigación clínica en pocos minutos.',
              guides: 'Guías de Seguridad',
              guidesDesc: 'Todo lo que necesitas saber sobre tus derechos como participante.',
              info: 'Info Básica',
              infoDesc: 'Introducción al mundo de la ciencia e innovación.'
            },
            feed: {
              rolePatient: 'Paciente · Comunidad',
              followers: 'Seguidores',
              following: 'Siguiendo',
              myGroups: 'MIS GRUPOS',
              members: 'Miembros',
              viewAllGroups: 'VER TODOS LOS GRUPOS',
              onlineFriends: 'AMIGOS ONLINE',
              composerPlaceholder: '¿Qué quieres compartir hoy?',
              photo: 'Foto',
              video: 'Video',
              feeling: 'Sentimiento',
              publish: 'Publicar',
              suggestedGroups: 'GRUPOS SUGERIDOS',
              join: 'Unirse',
              upcomingEvents: 'PRÓXIMOS EVENTOS',
              viewCalendar: 'VER CALENDARIO',
              peopleYouMayKnow: 'PERSONAS QUE PODRÍAS CONOCER',
              resourceLibrary: 'Biblioteca de Recursos',
              likes: 'Likes',
              comments: 'Comentarios',
              translating: 'Traduciendo...',
              like: 'Me gusta',
              comment: 'Comentar',
              share: 'Compartir'
            }
          },
          signup: {
            subtitle: 'Únete a la red líder en innovación científica.',
            role: 'Tipo de cuenta',
            roleOptions: {
              patient: 'Paciente / Aspirante',
              researcher: 'Investigador / Científico',
              healthProfessional: 'Profesional de la Salud',
              institution: 'Institución'
            },
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Correo electrónico',
            password: 'Contraseña',
            confirmPassword: 'Confirmar Contraseña',
            country: 'País',
            terms: 'Al registrarte, aceptas nuestros',
            termsLink: 'Términos y Condiciones',
            submit: 'Registrarse ahora',
            alreadyHaveAccount: '¿Ya tienes una cuenta?',
            loginHere: 'Inicia sesión aquí',
            orRegisterWith: 'O regístrate con',
            passwordsDontMatch: 'Las contraseñas no coinciden',
            validation: {
              fieldRequired: 'Este campo es requerido',
              invalidEmail: 'Por favor ingresa un correo válido',
              institutionalEmailRequired: 'Los investigadores e instituciones deben usar un correo institucional',
              commonEmailDomains: 'Usa un correo de tu institución (no Gmail, Outlook, Yahoo, etc.)',
              passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
              passwordWeak: 'La contraseña debe contener mayúscula, minúscula, número y carácter especial',
              affirmTerms: 'Debes aceptar los términos y condiciones',
              invalidAffiliation: 'Debes indicar tu afiliación profesional',
              invalidDiseaseOfInterest: 'Debes indicar la enfermedad de tu interés',
              invalidInstitutionName: 'Debes indicar el nombre de la institución',
              countryRequired: 'Debes seleccionar un país'
            },
            orcid: 'ORCID',
            orcidPlaceholder: 'XXXX-XXXX-XXXX-XXXX',
            orcidVerificationMsg: '¿Eres investigador? Podrás verificar tu identidad con ORCID una vez tu cuenta esté activa.',
            affiliation: 'Afiliación Profesional',
            affiliationPlaceholder: 'Ej: Universidad Nacional, Hospital Central',
            clinicalStudyParticipant: '¿Has participado en algún estudio clínico?',
            diseaseOfInterest: '¿Para qué enfermedad buscas información?',
            diseaseOfInterestPlaceholder: 'Ej: Cáncer de pulmón, Diabetes tipo 2',
            userType: 'Soy un...',
            userTypeOptions: {
              patient: 'Paciente',
              familyMember: 'Familiar',
              caregiver: 'Cuidador'
            },
            institutionName: 'Nombre de la Institución',
            institutionNamePlaceholder: 'Ej: Universidad Nacional, Hospital Central',
            institutionType: 'Tipo de Institución',
            institutionTypeOptions: {
              university: 'Universidad',
              hospital: 'Hospital',
              researchCenter: 'Centro de Investigación',
              pharmaceutical: 'Farmacéutica',
              other: 'Otro'
            },
            website: 'Sitio Web',
          },
          sidebar: {
            platform: 'PLATAFORMA',
            red: 'Red',
            scientificSearch: 'Búsqueda Científica',
            grants: 'Grants',
            grupos: 'Grupos Colaborativos',
            projects: 'Proyectos',
            eventsWebinars: 'Eventos y Webinars',
            mySpace: 'MI ESPACIO',
            myProjects: 'Mis Proyectos',
            saved: 'Guardados',
            analytics: 'Analíticas',
            activeStudies: 'ESTUDIOS ACTIVOS',
            settings: 'Configuración'
          },
          portal: {
            nav: {
              start: 'Inicio',
              network: 'Red',
              projects: 'Proyectos',
              publications: 'Búsqueda Científica',
              groups: 'Grupos Colaborativos',
              training: 'Capacitación',
              config: 'Configuración'
            },
            newResearch: 'Nueva Investigación',
            searchPlaceholder: 'Busca investigaciones, protocolos o investigadores...',
            userMenu: {
              editProfile: 'Editar perfil',
              myPubs: 'Mis publicaciones',
              logout: 'Cerrar sesión'
            },
            welcome: '¡Bienvenido de nuevo, {{name}}!',
            statsSummary: 'Tu portafolio de investigación muestra un 15% más de progreso este mes. Tienes 2 estudios en fase crítica de reclutamiento y 1 protocolo esperando firma IA.',
            trialsHeader: 'Ensayos Clínicos Activos',
            viewAll: 'Ver todos',
            trialStatus: {
              recruiting: 'Reclutamiento abierto',
              followUp: 'En seguimiento'
            },
            trialPhase: 'Fase {{phase}}',
            nextMilestone: 'Próximo hito: {{milestone}}',
            pubsHeader: 'Publicaciones Recientes',
            networkHeader: 'Mi Red y Solicitudes',
            accept: 'Aceptar',
            reject: 'Rechazar',
            accepted: 'Aceptaste la solicitud de {{name}}',
            rejected: 'Solicitud rechazada',
            quickResources: 'Recursos Rápidos',
            agenda: 'Agenda Científica',
            formats: 'Formatos y Plantillas',
            tutorials: 'Video Tutoriales',
            library: 'Biblioteca Completa',
            grantBtn: 'Aplicar ahora'
          },
          lifecycle: {
            title: 'IA Lifecycle',
            subtitle: 'Potencia tu investigación con herramientas predictivas',
            newIdea: 'Nueva Idea',
            protocol: 'Protocolo',
            management: 'Gestión',
            aiWriting: 'Redacción IA'
          },
          researcherDashboard: {
            title: "Portal del Investigador Clínico",
            subtitle: "Potenciando la investigación científica con tecnología de vanguardia y recursos especializados.",
            resourcesTitle: "Recursos para la Investigación",
            events: {
              title: "Eventos Científicos",
              desc: "Calendario actualizado de congresos, webinars, simposios internacionales y jornadas de actualización clínica.",
              link: "Ver calendario →"
            },
            formats: {
              title: "Formatos y Plantillas",
              desc: "Acceso inmediato a modelos de eCRF, Consentimientos Informados, Protocolos y guías de buenas prácticas.",
              link: "Explorar biblioteca →"
            },
            tutorials: {
              title: "Tutoriales de Investigación",
              desc: "Videos especializados sobre metodología científica, estadística y gestión de plataformas de datos.",
              link: "Ver videos →"
            },
            cta: {
              title: "Únete a la Red de Colaboración",
              desc: "Conéctate con investigadores de todo el mundo, comparte conocimiento y lidera proyectos multicéntricos de alto impacto.",
              btn: "Unirse a la Red"
            },
            footer: {
              tagline: "Líderes en la transformación digital de la investigación clínica a nivel global.",
              colResources: "Recursos",
              colCompany: "Empresa",
              colLegal: "Legal",
              about: "Nosotros",
              projects: "Proyectos",
              contact: "Contacto",
              privacy: "Privacidad",
              terms: "Términos",
              cookies: "Cookies",
              copyright: "© 2024 EcoScienceInnova. Todos los derechos reservados."
            }
          },
          auth: {
            loginTitle: 'Inicia sesión en tu cuenta',
            registerTitle: 'Crea una cuenta',
            email: 'Correo electrónico',
            password: 'Contraseña',
            forgotPassword: '¿Olvidaste tu contraseña?',
            loginBtn: 'Iniciar Sesión',
            registerBtn: 'Registrarse',
            socialLogin: 'O inicia sesión con',
            verify2FA: 'Verificar 2FA',
            twoFactorCode: 'Código 2FA',
            verifyBtn: 'Verificar',
            invalidCredentials: 'Correo o contraseña inválidos',
            welcomeBack: '¡Bienvenido de nuevo!',
            noAccount: '¿No tienes una cuenta?',
            alreadyHaveAccount: '¿Ya tienes una cuenta?'
          },
          profile: {
            title: 'Mi Perfil',
            basicInfo: 'Información Básica',
            firstName: 'Nombre',
            lastName: 'Apellido',
            bio: 'Biografía',
            country: 'País',
            saveBtn: 'Guardar Cambios',
            completion: 'Progreso del Perfil',
            requestValidation: 'Solicitar Validación Profesional'
          },
          scientific: {
            title: 'Explorador Científico',
            subtitle: 'Descubre y sintetiza evidencia científica con Inteligencia Artificial.',
            searchPlaceholder: 'Ingresa un tema, fármaco o patología...',
            btnSearch: 'Buscar',
            pipelineTitle: 'Trazabilidad del Pipeline',
            meshExpansion: 'Expansión MeSH',
            multiSourceSearch: 'Búsqueda Multi-Fuente',
            semanticRanking: 'Ranking Semántico',
            persistence: 'Persistencia en BD',
            generateSynthesis: 'Generar Síntesis Consolidada',
            selectedArticles: 'artículos seleccionados',
            narrativeSynthesis: 'Síntesis Narrativa IA',
            exportPdf: 'Exportar a PDF'
          },
          articleDetail: {
            back: 'Regresar',
            translate: 'Traducir',
            translating: 'Traduciendo',
            originalPdf: 'PDF Original',
            tabs: {
              summary: 'Resumen',
              methodology: 'Metodología',
              findings: 'Hallazgos y Evidencia',
              translation: 'Traducción'
            },
            clinicalRelevance: 'Importancia Clínica',
            aiAnalysis: 'Análisis Inteligente EcoAI',
            analyzeBtn: 'Analizar artículo con IA',
            aiSuccess: 'Análisis IA completo',
            evidenceTools: 'Herramientas de Evidencia',
            languageWarning: 'Este artículo está en {{lang}}. ¿Deseas traducirlo?',
            translateNow: 'Traducir ahora'
          }
        }
      },
      en: {
        translation: {
          welcome: 'Welcome to EcoScienceInnova',
          login: 'Login',
          register: 'Register',
          chatPlaceholder: 'Type your message...',
          changeLanguage: 'Change language to',
          home: 'Home',
          comunidad: 'Community',
          memberships: 'Memberships',
          contact: 'Contact',
          tagline: 'Science and Innovation with real impact',
          investigador: 'Researcher',
          investigadorDesc: 'Manage your studies, publish results and coordinate clinical research with advanced tools.',
          investigadorBtn: 'I am a researcher',
          aspirante: 'Study applicant',
          aspiranteDesc: 'Participate in cutting-edge clinical trials, contribute to science and access new treatments.',
          aspiranteBtn: 'I want to participate',
          institucion: 'Institutions',
          institucionDesc: 'Participate in research with real impact and contact research talent.',
          institucionBtn: 'Register entity',
          footerText: 'Connecting medical research with the future through technological innovation.',
          followUs: 'Follow us:',
          platform: 'Platform',
          studies: 'Studies',
          howItWorks: 'How it works',
          dataSecurity: 'Data security',
          company: 'Company',
          press: 'Press',
          legal: 'Legal',
          termsOfService: 'Terms of service',
          ethicsCode: 'Ethics code',
          acercaDe: 'About',
          common: {
            privacy: 'Privacy',
            terms: 'Terms',
            cookies: 'Cookies'
          },
          header: {
            aiSearchPlaceholder: 'Ask the research AI...'
          },
          tabs: {
            forYou: 'For you',
            recent: 'Recent',
            myTopics: 'My topics',
            filter: 'Filter'
          },
          composer: {
            placeholder: 'What are you researching today?',
            publish: 'Publish'
          },
          post: {
            share: 'Share',
            mentions: 'Mentions'
          },
          widgets: {
            ecoAiInsight: 'EcoAI Insight',
            insightDesc: 'Based on your recent activity, we recommend reviewing the new Phase II immunotherapy safety protocol.',
            viewRecommendation: 'View recommendation',
            trendsTitle: 'Trending topics',
            viewMoreSuggestions: 'View more suggestions'
          },
          community: {
            hero: {
              title: 'A Vibrant Community',
              subtitle: 'Join thousands of patients and researchers in the scientific revolution.',
              registerBtn: 'Register and Join',
              chat: 'Secret Chat',
              supportGroups: 'Support Groups',
              shareExperiences: 'Share Experiences'
            },
            search: {
              placeholder: 'Ask the AI? e.g.: How does a clinical trial work?',
              btn: 'Consult Community AI'
            },
            results: {
              title: 'AI Insights for you',
              study: 'Clinical Research',
              recommended: 'Recommended',
              glosary: 'Medical Glossary',
              apply: 'Apply to participate',
              learnMore: 'Learn more'
            },
            resources: {
              title: 'Educational Resources',
              subtitle: 'Content curated by specialists for your well-being.',
              tag: '100% EDUCATION',
              videos: 'Video Tutorials',
              videosDesc: 'Learn the basics of clinical research in a few minutes.',
              guides: 'Security Guides',
              guidesDesc: 'Everything you need to know about your rights as a participant.',
              info: 'Basic Info',
              infoDesc: 'Introduction to the world of science and innovation.'
            },
            feed: {
              rolePatient: 'Patient · Community',
              followers: 'Followers',
              following: 'Following',
              myGroups: 'MY GROUPS',
              members: 'Members',
              viewAllGroups: 'VIEW ALL GROUPS',
              onlineFriends: 'ONLINE FRIENDS',
              composerPlaceholder: 'What do you want to share today?',
              photo: 'Photo',
              video: 'Video',
              feeling: 'Feeling',
              publish: 'Publish',
              suggestedGroups: 'SUGGESTED GROUPS',
              join: 'Join',
              upcomingEvents: 'UPCOMING EVENTS',
              viewCalendar: 'VIEW CALENDAR',
              peopleYouMayKnow: 'PEOPLE YOU MAY KNOW',
              resourceLibrary: 'Resource Library',
              likes: 'Likes',
              comments: 'Comments',
              like: 'Like',
              comment: 'Comment',
              share: 'Share'
            }
          },
          yes: 'Yes',
          no: 'No',
          signup: {
            subtitle: 'Join the leading network in scientific innovation.',
            role: 'Account Type',
            roleOptions: {
              patient: 'Patient / Applicant',
              researcher: 'Researcher / Scientist',
              healthProfessional: 'Health Professional',
              institution: 'Institution'
            },
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email Address',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            country: 'Country',
            terms: 'By registering, you agree to our',
            termsLink: 'Terms and Conditions',
            submit: 'Register Now',
            alreadyHaveAccount: 'Already have an account?',
            loginHere: 'Log in here',
            orRegisterWith: 'Or register with',
            passwordsDontMatch: 'Passwords do not match',
            validation: {
              fieldRequired: 'This field is required',
              invalidEmail: 'Please enter a valid email',
              institutionalEmailRequired: 'Researchers and institutions must use an institutional email',
              commonEmailDomains: 'Use an email from your institution (not Gmail, Outlook, Yahoo, etc.)',
              passwordTooShort: 'Password must be at least 8 characters',
              passwordWeak: 'Password must contain uppercase, lowercase, number and special character',
              affirmTerms: 'You must accept the terms and conditions',
              invalidAffiliation: 'You must indicate your professional affiliation',
              invalidDiseaseOfInterest: 'You must indicate the disease you are interested in',
              invalidInstitutionName: 'You must indicate the institution name',
              countryRequired: 'You must select a country'
            },
            orcid: 'ORCID',
            orcidPlaceholder: 'XXXX-XXXX-XXXX-XXXX',
            orcidVerificationMsg: 'Are you a researcher? You can verify your identity with ORCID once your account is active.',
            affiliation: 'Professional Affiliation',
            affiliationPlaceholder: 'e.g., National University, Central Hospital',
            clinicalStudyParticipant: 'Have you participated in a clinical study?',
            diseaseOfInterest: 'For which disease are you seeking information?',
            diseaseOfInterestPlaceholder: 'e.g., Lung Cancer, Type 2 Diabetes',
            userType: 'I am a...',
            userTypeOptions: {
              patient: 'Patient',
              familyMember: 'Family Member',
              caregiver: 'Caregiver'
            },
            institutionName: 'Institution Name',
            institutionNamePlaceholder: 'e.g., National University, Central Hospital',
            institutionType: 'Institution Type',
            institutionTypeOptions: {
              university: 'University',
              hospital: 'Hospital',
              researchCenter: 'Research Center',
              pharmaceutical: 'Pharmaceutical',
              other: 'Other'
            },
            website: 'Website',
          },
          sidebar: {
            platform: 'PLATFORM',
            red: 'Network',
            scientificSearch: 'Scientific Search',
            grants: 'Grants',
            grupos: 'Collaborative Groups',
            projects: 'Projects',
            eventsWebinars: 'Events & Webinars',
            mySpace: 'MY SPACE',
            myProjects: 'My Projects',
            saved: 'Saved',
            analytics: 'Analytics',
            activeStudies: 'ACTIVE STUDIES',
            settings: 'Settings'
          },
          portal: {
            nav: {
              start: 'Home',
              network: 'Network',
              projects: 'Projects',
              publications: 'Scientific Search',
              groups: 'Collaborative Groups',
              training: 'Training',
              config: 'Settings'
            },
            newResearch: 'New Research',
            searchPlaceholder: 'Search for research, protocols or researchers...',
            userMenu: {
              editProfile: 'Edit profile',
              myPubs: 'My publications',
              logout: 'Logout'
            },
            welcome: 'Welcome back, {{name}}!',
            statsSummary: 'Your research portfolio shows 15% more progress this month. You have 2 studies in critical recruitment phase and 1 protocol waiting for AI signature.',
            trialsHeader: 'Active Clinical Trials',
            viewAll: 'View all',
            trialStatus: {
              recruiting: 'Open recruitment',
              followUp: 'In follow-up'
            },
            trialPhase: 'Phase {{phase}}',
            nextMilestone: 'Next milestone: {{milestone}}',
            pubsHeader: 'Recent Publications',
            networkHeader: 'My Network and Requests',
            accept: 'Accept',
            reject: 'Reject',
            accepted: 'Accepted request from {{name}}',
            rejected: 'Request rejected',
            quickResources: 'Quick Resources',
            agenda: 'Scientific Agenda',
            formats: 'Formats & Templates',
            tutorials: 'Video Tutorials',
            library: 'Full Library',
            grantBtn: 'Apply now'
          },
          lifecycle: {
            title: 'AI Lifecycle',
            subtitle: 'Power your research with predictive tools',
            newIdea: 'New Idea',
            protocol: 'Protocol',
            management: 'Management',
            aiWriting: 'AI Writing'
          },
          researcherDashboard: {
            title: "Clinical Researcher Portal",
            subtitle: "Empowering scientific research with cutting-edge technology and specialized resources.",
            resourcesTitle: "Research Resources",
            events: {
              title: "Scientific Events",
              desc: "Updated calendar of congresses, webinars, international symposia and clinical update sessions.",
              link: "View calendar →"
            },
            formats: {
              title: "Formats and Templates",
              desc: "Immediate access to eCRF models, Informed Consents, Protocols and best practice guides.",
              link: "Explore library →"
            },
            tutorials: {
              title: "Research Tutorials",
              desc: "Specialized videos on scientific methodology, statistical analysis and data platform management.",
              link: "View videos →"
            },
            cta: {
              title: "Join the Collaboration Network",
              desc: "Connect with researchers from all over the world, share knowledge and lead high-impact multicenter projects.",
              btn: "Join the Network"
            },
            footer: {
              tagline: "Leaders in the digital transformation of clinical research globally.",
              colResources: "Resources",
              colCompany: "Company",
              colLegal: "Legal",
              about: "About Us",
              projects: "Projects",
              contact: "Contact",
              privacy: "Privacy",
              terms: "Terms",
              cookies: "Cookies",
              copyright: "© 2024 EcoScienceInnova. All rights reserved."
            }
          },
          auth: {
            loginTitle: 'Login to your account',
            registerTitle: 'Create an account',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Forgot password?',
            loginBtn: 'Login',
            registerBtn: 'Register',
            socialLogin: 'Or login with',
            verify2FA: 'Verify 2FA',
            twoFactorCode: '2FA Code',
            verifyBtn: 'Verify',
            invalidCredentials: 'Invalid email or password',
            welcomeBack: 'Welcome back!',
            noAccount: "Don't have an account?",
            alreadyHaveAccount: 'Already have an account?'
          },
          profile: {
            title: 'My Profile',
            basicInfo: 'Basic Information',
            firstName: 'First Name',
            lastName: 'Last Name',
            bio: 'Biography',
            country: 'Country',
            saveBtn: 'Save Changes',
            completion: 'Profile Completion',
            requestValidation: 'Request Professional Validation'
          },
          scientific: {
            title: 'Scientific Explorer',
            subtitle: 'Discover and synthesize scientific evidence with Artificial Intelligence.',
            searchPlaceholder: 'Enter a topic, drug or pathology...',
            btnSearch: 'Search',
            pipelineTitle: 'Pipeline Traceability',
            meshExpansion: 'MeSH Expansion',
            multiSourceSearch: 'Multi-Source Search',
            semanticRanking: 'Semantic Ranking',
            persistence: 'DB Persistence',
            generateSynthesis: 'Generate Consolidated Synthesis',
            selectedArticles: 'articles selected',
            narrativeSynthesis: 'AI Narrative Synthesis',
            exportPdf: 'Export to PDF'
          },
          articleDetail: {
            back: 'Back',
            translate: 'Translate',
            translating: 'Translating',
            originalPdf: 'Original PDF',
            tabs: {
              summary: 'Summary',
              methodology: 'Methodology',
              findings: 'Findings & Evidence',
              translation: 'Translation'
            },
            clinicalRelevance: 'Clinical Relevance',
            aiAnalysis: 'EcoAI Intelligent Analysis',
            analyzeBtn: 'Analyze article with AI',
            aiSuccess: 'AI Analysis complete',
            evidenceTools: 'Evidence Tools',
            languageWarning: 'This article is in {{lang}}. Do you want to translate it?',
            translateNow: 'Translate now'
          }
        }
      },
      pt: {
        translation: {
          welcome: 'Bem-vindo ao EcoScienceInnova',
          login: 'Entrar',
          register: 'Registrar',
          yes: 'Sim',
          no: 'Não',
          chatPlaceholder: 'Digite sua mensagem...',
          changeLanguage: 'Alterar idioma para',
          home: 'Início',
          comunidad: 'Comunidade',
          memberships: 'Assinaturas',
          contact: 'Contato',
          tagline: 'Ciência e Inovação com impacto real',
          investigador: 'Pesquisador',
          investigadorDesc: 'Gerencie seus estudos, publique resultados e coordene pesquisas clínicas com ferramentas avançadas.',
          investigadorBtn: 'Sou pesquisador',
          aspirante: 'Candidato ao estudo',
          aspiranteDesc: 'Participe de ensaios clínicos de ponta, contribua para a ciência e acesse novos tratamentos.',
          aspiranteBtn: 'Quero participar',
          institucion: 'Instituições',
          institucionDesc: 'Participe de pesquisas com impacto real e contate talentos de pesquisa.',
          institucionBtn: 'Registrar entidade',
          footerText: 'Conectando a pesquisa médica com o futuro por meio da inovação tecnológica.',
          followUs: 'Siga-nos:',
          auth: {
            loginTitle: 'Entre na sua conta',
            registerTitle: 'Crie uma conta',
            email: 'E-mail',
            password: 'Senha',
            forgotPassword: 'Esqueceu a senha?',
            loginBtn: 'Entrar',
            registerBtn: 'Registrar',
            socialLogin: 'Ou entre com',
            verify2FA: 'Verificar 2FA',
            twoFactorCode: 'Código 2FA',
            verifyBtn: 'Verificar',
            invalidCredentials: 'E-mail ou senha inválidos',
            welcomeBack: 'Bem-vindo de volta!',
            noAccount: 'Não tem uma conta?',
            alreadyHaveAccount: 'Já tem uma conta?'
          },
          community: {
            signup: {
              subtitle: 'Junte-se à rede líder em inovação científica.',
              role: 'Tipo de conta',
              roleOptions: {
                patient: 'Paciente / Candidato',
                researcher: 'Pesquisador / Cientista',
                healthProfessional: 'Profissional de Saúde',
                institution: 'Instituição'
              },
              firstName: 'Nome',
              lastName: 'Sobrenome',
              email: 'E-mail',
              password: 'Senha',
              confirmPassword: 'Confirmar Senha',
              country: 'País',
              terms: 'Ao registrar-se, você aceita nossos',
              termsLink: 'Termos e Condições',
              submit: 'Registrar agora',
              alreadyHaveAccount: 'Já tem uma conta?',
              loginHere: 'Faça login aqui',
              orRegisterWith: 'Ou registre-se com',
              passwordsDontMatch: 'As senhas não coincidem'
            }
          },
          profile: {
            title: 'Meu Perfil',
            basicInfo: 'Informação Básica',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            bio: 'Biografia',
            country: 'País',
            saveBtn: 'Salvar Alterações',
            completion: 'Progresso do Perfil',
            requestValidation: 'Solicitar Validação Profissional'
          },
          portal: {
            userMenu: {
              editProfile: 'Editar perfil',
              myPubs: 'Minhas publicações',
              logout: 'Sair'
            }
          }
        }
      },
      fr: {
        translation: {
          welcome: 'Bienvenue sur EcoScienceInnova',
          login: 'Connexion',
          register: 'S\'inscrire',
          yes: 'Oui',
          no: 'Non',
          chatPlaceholder: 'Tapez votre message...',
          changeLanguage: 'Changer la langue en',
          home: 'Accueil',
          comunidad: 'Communauté',
          memberships: 'Adhésions',
          contact: 'Contact',
          tagline: 'Science et Innovation avec un réel impact',
          investigador: 'Chercheur',
          investigadorBtn: 'Je suis Chercheur',
          aspirante: 'Candidat aux études',
          aspiranteBtn: 'Je veux participer',
          institucion: 'Institutions',
          institucionBtn: 'Enregistrer une entité',
          auth: {
            loginTitle: 'Connectez-vous à votre compte',
            registerTitle: 'Créer un compte',
            email: 'E-mail',
            password: 'Mot de passe',
            forgotPassword: 'Mot de passe oublié ?',
            loginBtn: 'Se connecter',
            registerBtn: 'S\'inscrire',
            socialLogin: 'Ou connectez-vous avec',
            verify2FA: 'Vérifier la 2FA',
            twoFactorCode: 'Code 2FA',
            verifyBtn: 'Vérifier',
            invalidCredentials: 'E-mail ou mot de passe invalide',
            welcomeBack: 'Bon retour !',
            noAccount: "Vous n'avez pas de compte ?",
            alreadyHaveAccount: 'Vous avez déjà un compte ?'
          },
          community: {
            signup: {
              subtitle: 'Rejoignez le premier réseau d\'innovation scientifique.',
              role: 'Type de compte',
              roleOptions: {
                patient: 'Patient / Candidat',
                researcher: 'Chercheur / Scientifique',
                healthProfessional: 'Professionnel de la Santé',
                institution: 'Institution'
              },
              firstName: 'Prénom',
              lastName: 'Nom',
              email: 'E-mail',
              password: 'Mot de passe',
              confirmPassword: 'Confirmer le mot de passe',
              country: 'Pays',
              terms: 'En vous inscrivant, vous acceptez nos',
              termsLink: 'Conditions Générales',
              submit: 'S\'inscrire maintenant',
              alreadyHaveAccount: 'Vous avez déjà un cuenta ?',
              loginHere: 'Connectez-vous ici',
              orRegisterWith: 'Ou connectez-vous avec',
              passwordsDontMatch: 'Les mots de passe ne correspondent pas',
              orcid: 'ORCID',
              orcidPlaceholder: 'XXXX-XXXX-XXXX-XXXX',
              orcidVerificationMsg: 'Êtes-vous chercheur? Vous pouvez vérifier votre identité avec ORCID une fois votre compte actif.',
              affiliation: 'Affiliation Professionnelle'
            }
          },
          profile: {
            title: 'Mon Profil',
            basicInfo: 'Informations de Base',
            firstName: 'Prénom',
            lastName: 'Nom',
            bio: 'Biographie',
            country: 'Pays',
            saveBtn: 'Enregistrer les Modifications',
            completion: 'Progression du Profil',
            requestValidation: 'Demander une Validation Professionnelle'
          },
          portal: {
            userMenu: {
              editProfile: 'Modifier le profil',
              myPubs: 'Mes publications',
              logout: 'Se déconnecter'
            }
          }
        }
      },
      it: {
        translation: {
          welcome: 'Benvenuto su EcoScienceInnova',
          login: 'Accedi',
          register: 'Registrati',
          yes: 'Sì',
          no: 'No',
          chatPlaceholder: 'Digita il tuo messaggio...',
          changeLanguage: 'Cambia lingua in',
          home: 'Home',
          comunidad: 'Comunità',
          memberships: 'Iscrizioni',
          contact: 'Contatti',
          tagline: 'Scienza e Innovazione con impatto reale',
          investigador: 'Ricercatore',
          investigadorBtn: 'Sono un Ricercatore',
          aspirante: 'Candidato agli studi',
          aspiranteBtn: 'Voglio partecipare',
          institucion: 'Istituzioni',
          institucionBtn: 'Registra un ente',
          auth: {
            loginTitle: 'Accedi al tuo account',
            registerTitle: 'Crea un account',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Password dimenticata?',
            loginBtn: 'Accedi',
            registerBtn: 'Registrati',
            socialLogin: 'O accedi con',
            verify2FA: 'Verifica 2FA',
            twoFactorCode: 'Codice 2FA',
            verifyBtn: 'Verifica',
            invalidCredentials: 'Email o password non valida',
            welcomeBack: 'Bentornato!',
            noAccount: 'Non hai un account?',
            alreadyHaveAccount: 'Hai già un account?'
          },
          community: {
            signup: {
              subtitle: 'Unisciti al primo network di innovazione scientifica.',
              role: 'Tipo di account',
              roleOptions: {
                patient: 'Paziente / Candidato',
                researcher: 'Ricercatore / Scienziato',
                healthProfessional: 'Professionista Sanitario',
                institution: 'Istituzione'
              },
              firstName: 'Nome',
              lastName: 'Cognome',
              email: 'Email',
              password: 'Password',
              confirmPassword: 'Conferma Password',
              country: 'Paese',
              terms: 'Registrandoti, accetti i nostri',
              termsLink: 'Termini e Condizioni',
              submit: 'Registrati ora',
              alreadyHaveAccount: 'Hai già un account?',
              loginHere: 'Accedi qui',
              orRegisterWith: 'O registrati con',
              passwordsDontMatch: 'Le password non corrispondono'
            }
          },
          profile: {
            title: 'Il Mio Profilo',
            basicInfo: 'Informazioni di Base',
            firstName: 'Nome',
            lastName: 'Cognome',
            bio: 'Biografia',
            country: 'Paese',
            saveBtn: 'Salva Modifiche',
            completion: 'Completamento Profilo',
            requestValidation: 'Richiedi Convalida Professionale'
          },
          portal: {
            userMenu: {
              editProfile: 'Modifica profilo',
              myPubs: 'Le mie pubblicazioni',
              logout: 'Esci'
            }
          }
        }
      },
      de: {
        translation: {
          welcome: 'Willkommen bei EcoScienceInnova',
          login: 'Anmelden',
          register: 'Registrieren',
          yes: 'Ja',
          no: 'Nein',
          chatPlaceholder: 'Geben Sie Ihre Nachricht ein...',
          changeLanguage: 'Sprache ändern in',
          home: 'Startseite',
          comunidad: 'Gemeinschaft',
          memberships: 'Mitgliedschaften',
          contact: 'Kontakt',
          tagline: 'Wissenschaft und Innovation mit echtem Impact',
          investigador: 'Forscher',
          investigadorBtn: 'Ich bin ein Forscher',
          aspirante: 'Studienbewerberin',
          aspiranteBtn: 'Ich möchte teilnehmen',
          institucion: 'Institutionen',
          institucionBtn: 'Entität registrieren',
          auth: {
            loginTitle: 'Melden Sie sich bei Ihrem Konto an',
            registerTitle: 'Konto erstellen',
            email: 'E-Mail',
            password: 'Passwort',
            forgotPassword: 'Passwort vergessen?',
            loginBtn: 'Anmelden',
            registerBtn: 'Registrieren',
            socialLogin: 'Oder melden Sie sich an mit',
            verify2FA: 'Bestätigen Sie 2FA',
            twoFactorCode: '2FA-Code',
            verifyBtn: 'Bestätigen',
            invalidCredentials: 'E-Mail oder Passwort ungültig',
            welcomeBack: 'Willkommen zurück!',
            noAccount: 'Sie haben noch kein Konto?',
            alreadyHaveAccount: 'Haben Sie bereits ein Konto?'
          },
          community: {
            signup: {
              subtitle: 'Treten Sie dem führenden Netzwerk für wissenschaftliche Innovation bei.',
              role: 'Kontotyp',
              roleOptions: {
                patient: 'Patient / Bewerber',
                researcher: 'Forscher / Wissenschaftler',
                healthProfessional: 'Gesundheitsfachkraft',
                institution: 'Institution'
              },
              firstName: 'Vorname',
              lastName: 'Nachname',
              email: 'E-Mail',
              password: 'Passwort',
              confirmPassword: 'Passwort bestätigen',
              country: 'Land',
              terms: 'Mit der Registrierung stimmen Sie unseren zu',
              termsLink: 'Allgemeinen Geschäftsbedingungen',
              submit: 'Jetzt registrieren',
              alreadyHaveAccount: 'Sie haben bereits ein Konto?',
              loginHere: 'Melden Sie sich hier an',
              orRegisterWith: 'Oder registrieren Sie sich mit',
              passwordsDontMatch: 'Passwörter stimmen nicht überein'
            }
          },
          profile: {
            title: 'Mein Profil',
            basicInfo: 'Grundinformationen',
            firstName: 'Vorname',
            lastName: 'Nachname',
            bio: 'Biografie',
            country: 'Land',
            saveBtn: 'Änderungen speichern',
            completion: 'Profilvervollständigung',
            requestValidation: 'Professionelle Validierung anfordern'
          },
          portal: {
            userMenu: {
              editProfile: 'Profil bearbeiten',
              myPubs: 'Meine Veröffentlichungen',
              logout: 'Abmelden'
            }
          }
        }
      }
    }
  });


export default i18n;